"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _designLanguage = require("@doordash/design-language");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ErrorMessage = function ErrorMessage(_ref) {
  var id = _ref.id,
      error = _ref.error;
  return _react.default.createElement(_designLanguage.InlineChildren, {
    size: _designLanguage.InlineChildren.Sizes.XxSmall,
    alignItems: _designLanguage.InlineChildren.Alignment.Center,
    justifyContent: _designLanguage.InlineChildren.Justification.FlexStart,
    id: id
  }, _react.default.createElement(_designLanguage.Icon, {
    type: _designLanguage.Icon.Types.WarningCircleFill,
    size: _designLanguage.Icon.Sizes.Small,
    color: _designLanguage.Colors.ErrorText,
    title: "Error"
  }), _react.default.createElement(_designLanguage.BaseText, {
    styles: _designLanguage.BaseText.Styles.Medium14,
    color: _designLanguage.Colors.ErrorText
  }, error));
};

ErrorMessage.propTypes = {
  error: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]).isRequired,
  id: _propTypes.default.string
};
var _default = ErrorMessage;
exports.default = _default;